var map = {
	"./black/mute_camera.png": "WLyp",
	"./blue/mute_camera.png": "DyLU",
	"./white/mute_camera.png": "0/za"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yjF8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/mute_camera\.png$
// module id = yjF8
// module chunks = 24